import React, {ReactElement} from 'react';
import {IconSize} from '../types';
import IconWrapper, {IconProps} from '../IconWrapper';

export function PlusCircle(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props} size={IconSize.MEDIUM}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5222 17.5233 22 12 22C6.47777 22 2 17.5222 2 12C2 6.47777 6.47777 2 12 2C17.5233 2 22 6.47784 22 12ZM12 20C16.4186 20 20 16.4177 20 12C20 7.58227 16.4186 4 12 4C7.58234 4 4 7.58234 4 12C4 16.4177 7.58234 20 12 20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8C12.5523 8 13 8.44772 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.44772 11.4477 8 12 8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9C8.44772 13 8 12.5523 8 12Z"
        fill="currentColor"
      />
    </IconWrapper>
  );
}
